import { useInstrumentsDynamicDict } from '@/controllers/gridManager/datafeedManager/datafeedManager';
import { memo, useEffect } from 'react';

type Props = {
    symbol: string,
    keyChange?: string,
    applyTransactionAsyncRealtime: (instrument: any, symbol: string) => void
}

const SymbolVirtualRow = memo(function SymbolVirtualRow({ symbol, applyTransactionAsyncRealtime, keyChange }: Props) {
    const { instrumentsDynamicDict } = useInstrumentsDynamicDict()

    // console.log('ha_check_SymbolVirtualRow', instrumentsDynamicDict[symbol])
    useEffect(() => {
        if (keyChange && instrumentsDynamicDict[symbol] && instrumentsDynamicDict[symbol]?.keysChange?.includes(keyChange)) {
            instrumentsDynamicDict[symbol] && applyTransactionAsyncRealtime(instrumentsDynamicDict[symbol], symbol)
        } else if (keyChange === undefined) {
            instrumentsDynamicDict[symbol] && applyTransactionAsyncRealtime(instrumentsDynamicDict[symbol], symbol)
        }
    }, [instrumentsDynamicDict[symbol]])
    return (
        null
        // <div>SymbolVirtualRow{instrument && JSON.stringify(instrument)}</div>
    )
});

export default SymbolVirtualRow